const columns = [
  {
    title: "Adhoc",
    field: "HOC",
    locked: false,
    filter: "text",
    width: 120,
    show: true,
  },
  {
    title: "SI DT",
    field: "SalaryIncrementDate",
    locked: false,
    filter: "date",
    format: "MM/DD/YYYY",
    editor: "date",
    width: 160,
    show: true,
  },

  {
    title: "Position Title",
    field: "Position",
    locked: false,
    filter: "text",
    width: 190,
    show: true,
  },
  {
    title: "Department",
    field: "DepartmentName",
    locked: false,
    filter: "text",
    width: 300,
    show: true,
  },
  {
    title: "Grade/Step",
    field: "GradenStep",
    locked: false,
    filter: "text",
    width: "150px",
    show: true,
  },
  {
    title: "Rating",
    field: "Rating",
    locked: false,
    filter: "text",
    width: "130px",
    show: true,
  },
  {
    title: "Score",
    field: "Score",
    locked: false,
    filter: "numeric",
    // editor:"numeric",
    width: "130px",
    show: true,
    headerClassName: "number-align",
    className: "text-end",
  },
];

export default columns;
